<template>
  <div class="c-order-status">
    <c-filter-tabs class="testred" :tabs="orderStatusTabs" @selected="onOrderStatusTabSelected"></c-filter-tabs>
  </div>
</template>

<script>
import CFilterTabs from '@custom/CFilterTabs';
export default {
  name: 'c-order-status',
  components: { CFilterTabs },
  props: {},
  computed: {
    i18nNamespace() {
      return 'white-label.components.order-status';
    }
  },
  data() {
    return {
      orderStatusTabs: [
        { name: 'open', pressed: false },
        { name: 'filled', pressed: false },
        { name: 'cancelled', pressed: false },
        { name: 'todays', pressed: false },
        { name: 'all', pressed: true }
      ]
    };
  },
  methods: {
    onOrderStatusTabSelected(tab) {
      console.log('onOrderStatusTabSelected', tab);
      this.orderStatusTabs.map((item, idx) => {
        item.pressed = false;
        if (idx === tab.index) {
          item.pressed = true;
        }
        return item;
      });
    },
    onHistoricalOrderTabsSelected(tab) {
      console.log('onHistoricalOrderTabsSelected', tab);
      this.historicalOrdersTabs.map((item, idx) => {
        item.pressed = false;
        if (idx === tab.index) {
          item.pressed = true;
        }
        return item;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-order-status';
</style>
